import React from "react";
import { createRoot } from "react-dom/client";
import App, { warmRoute } from "./App";

const container = document.getElementById("root");
const root = createRoot(container!);

// Kein Init-Vorlauf mehr: der Login laeuft ueber utils/auth.ts direkt gegen den
// eigenen IdP. Das ID-Token liegt in localStorage["oidc-token"], die Rueckleitung
// wird von der Route /login/callback verarbeitet (App.tsx).
// Erst das Stueck der aufgerufenen Adresse holen, dann rendern.
//
// Seit die Routenseiten nachgeladen werden (App.tsx), waere die Seite sonst
// beim ERSTEN Aufbau zweigeteilt: Navigation und Footer sofort, der Inhalt
// eine Anfrage spaeter. Beim Klicken im Portal ist genau das richtig - dort
// steht ein Platzhalter im Inhaltsbereich. Beim Aufruf von aussen dagegen
// (Lesezeichen, Rueckleitung des IdP, F5) hat der Nutzer nichts angeklickt;
// dort wirkt eine halb aufgebaute Seite wie ein Fehler.
//
// warmRoute liefert IMMER ein erfuelltes Versprechen - auch wenn das Holen
// scheitert oder die Adresse zu keiner nachgeladenen Seite gehoert.
//
// ABGEFANGEN IST DAMIT NUR DIE ABLEHNUNG, NICHT DAS HAENGENBLEIBEN. Eine
// Anfrage, die auf einer schlechten Mobilverbindung einfach offen bleibt,
// lehnt nicht ab - sie antwortet nur nicht. Ohne Frist stuende root.render
// so lange aus, und der Nutzer saehe eine VOLLSTAENDIG leere Seite: keine
// Navigation, kein Footer, nicht einmal der Platzhalter, weil noch gar nichts
// gerendert wurde. Vor dieser Runde konnte nur EINE Anfrage haengen (das
// Buendel), jetzt sind es zwei in Reihe.
//
// Deshalb ein Wettlauf gegen eine Frist. Der Nutzen des Vorwaermens bleibt -
// im Normalfall ist das Stueck laengst da, es ist klein (19-50 kB) und wird
// parallel zum Einstieg geholt. Nur der schlechte Fall endet jetzt anders:
// nach der Frist rendert React ohnehin, zeigt Navigation, Footer und im
// Inhalt den Platzhalter, und React.lazy setzt den bereits laufenden Abruf
// fort. Es geht also nichts verloren, es wird nur nicht mehr gewartet.
//
// 400 ms, weil die Frist zwei Dinge gleichzeitig treffen muss: sie darf im
// Normalfall nie zuschlagen (dann blitzte der Platzhalter unnoetig auf, genau
// das soll das Vorwaermen ja verhindern), und sie muss kuerzer sein als die
// Geduld eines Menschen vor einer weissen Flaeche. Ein Stueck aus dem Cache
// oder vom lokalen Server ist in wenigen Millisekunden da.
const VORWAERMFRIST_MS = 400;

Promise.race([
  warmRoute(window.location.pathname),
  new Promise((weiter) => setTimeout(weiter, VORWAERMFRIST_MS)),
]).then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
